// extracted by mini-css-extract-plugin
export var label = "_5w-1";
export var reminder = "_5w-0";